import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import useAppModal from 'hooks/useAppModal';
import { PromoCode } from 'models/PromoCode';
import { useDeletePromoCode } from 'components/domain/promoCode/useDeletePromoCode';

interface ActionsCellProps<T> {
  row: Row<T>;
}

const ActionsCell = <T extends PromoCode>({ row }: ActionsCellProps<T>) => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();
  const { mutate: deletePromoCode, isLoading: isDeleting } =
    useDeletePromoCode();

  const handleDeleteClick = () => {
    openConfirmModal({
      onConfirm: () => deletePromoCode(row.original.uid),
      body: t('pageDiscountCodes.pageDiscountCodes.deleteConfirmMessage'),
      title: t('pageDiscountCodes.pageDiscountCodes.deleteTitle'),
      confirmColor: 'danger',
      confirmLabel: t('common.delete'),
    });
  };

  return (
    <Button
      bsStyle="link"
      data-testid="delete-promo-code-button"
      disabled={isDeleting}
      onClick={handleDeleteClick}
    >
      {t('common.delete')}
    </Button>
  );
};

export default ActionsCell;
